export const StoreType = {
  /** @deprecated BIO_SUPERMARKET is deprecated. Use LOCAL_RETAILER, RETAIL_CHAIN, ONLINE_RETAILER instead. */
  BioSupermarket: "BIO_SUPERMARKET",
  /** @deprecated CAFETERIA is deprecated. Use UNIVERSITY_CANTEEN instead. */
  Cafeteria: "CAFETERIA",
  Campus: "CAMPUS",
  Canteen: "CANTEEN",
  Caterer: "CATERER",
  /** @deprecated No longer supported */
  Default: "DEFAULT",
  DemoStore: "DEMO_STORE",
  Entertainment: "ENTERTAINMENT",
  Festival: "FESTIVAL",
  Franchisee: "FRANCHISEE",
  Hospital: "HOSPITAL",
  Internal: "INTERNAL",
  InternationalCateringCompany: "INTERNATIONAL_CATERING_COMPANY",
  InternationalChain: "INTERNATIONAL_CHAIN",
  LocalRetailer: "LOCAL_RETAILER",
  LostBowls: "LOST_BOWLS",
  NationalCateringCompany: "NATIONAL_CATERING_COMPANY",
  NationalChain: "NATIONAL_CHAIN",
  OnlineRetailer: "ONLINE_RETAILER",
  PublicEvents: "PUBLIC_EVENTS",
  Restaurant: "RESTAURANT",
  /** @deprecated RETAIL is deprecated. Use LOCAL_RETAILER, RETAIL_CHAIN, ONLINE_RETAILER instead. */
  Retail: "RETAIL",
  RetailChain: "RETAIL_CHAIN",
  ReturnBox: "RETURN_BOX",
  /** @deprecated REWE is deprecated. Use LOCAL_RETAILER, RETAIL_CHAIN, ONLINE_RETAILER instead. */
  Rewe: "REWE",
  SelfOperatedCanteen: "SELF_OPERATED_CANTEEN",
  /** @deprecated SERVICED_RETURN_BOX is deprecated. Use SERVICED_RETURN_BOX_PAID, SERVICED_RETURN_BOX_UNPAID instead. */
  ServicedReturnBox: "SERVICED_RETURN_BOX",
  ServicedReturnBoxPaid: "SERVICED_RETURN_BOX_PAID",
  ServicedReturnBoxUnpaid: "SERVICED_RETURN_BOX_UNPAID",
  SmallRestaurantChain: "SMALL_RESTAURANT_CHAIN",
  Stadium: "STADIUM",
  /** @deprecated SUPERMARKET is deprecated. Use LOCAL_RETAILER, RETAIL_CHAIN, ONLINE_RETAILER instead. */
  Supermarket: "SUPERMARKET",
  UniversityCanteen: "UNIVERSITY_CANTEEN",
  Venue: "VENUE",
  Warehouse: "WAREHOUSE",
};

export const getIsReturnStationType = (
  storeType,
) => {
  if (!storeType) {
    return false
  }
  return [
    StoreType.ReturnBox,
    StoreType.ServicedReturnBoxPaid,
    StoreType.ServicedReturnBoxUnpaid,
    StoreType.ServicedReturnBox,
  ].includes(storeType)
}
